import type { SVGProps } from 'react';

export const Help = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="-1 -1 34 34"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'help'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <path
        d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,1.68421053 C8.09360779,1.68421053 1.68421053,8.09360779 1.68421053,16 C1.68421053,23.9063922 8.09360779,30.3157895 16,30.3157895 C23.9063922,30.3157895 30.3157895,23.9063922 30.3157895,16 C30.3157895,8.09360779 23.9063922,1.68421053 16,1.68421053 Z M15.8155294,22.2056471 C16.6061176,22.2056471 17.2649412,22.8644706 17.2649412,23.6550588 C17.2649412,24.4456471 16.6061176,25.1044706 15.8155294,25.1044706 C15.0249412,25.1044706 14.3661176,24.4456471 14.3661176,23.6550588 C14.3661176,22.8644706 15.0249412,22.2056471 15.8155294,22.2056471 Z M16.1054118,7 C19.3204706,7 21.2705882,8.81835294 21.2705882,11.0847059 C21.2705882,15.064 16.1581176,15.4065882 16.1581176,17.9891765 C16.1581176,18.4108235 16.4216471,18.9378824 16.8696471,19.2804706 L15.2621176,19.9656471 C14.5505882,19.3595294 14.2343529,18.6216471 14.2343529,17.8310588 C14.2343529,14.4842353 19.0042353,14.1943529 19.0042353,11.4009412 C19.0042353,10.0832941 17.9764706,8.95011765 15.8945882,8.95011765 C13.9181176,8.95011765 12.6795294,9.81976471 11.7044706,11.1110588 L10.3868235,9.688 C11.6517647,8.05411765 13.6018824,7 16.1054118,7 Z"
        fill={props.fill}
      />
    </g>
  </svg>
);
